export function pascalToWords(pascalCase: string) {
  const words = [];
  let currentWord = '';

  for (let i = 0; i < pascalCase.length; i++) {
    const char = pascalCase[i];

    if (char.toUpperCase() === char) {
      // If the current character is uppercase, add the current word to the array
      // and start a new word.
      if (currentWord) {
        words.push(currentWord);
      }
      currentWord = char;
    } else {
      // If the current character is lowercase, append it to the current word.
      currentWord += char;
    }
  }

  // Add the final word to the array.
  if (currentWord) {
    words.push(currentWord);
  }

  return words.join(' ');
}
